import request from './request';

export async function list(
  page: number,
  perPage: number,
  search?: string,
  categoryId?: string
) {
  return request('GET', '/api/blog-posts', {
    page,
    perPage,
    search,
    categoryId,
  });
}

export async function create(
  title?: string,
  titleEn?: string,
  titleDe?: string,
  slug?: string,
  content?: string,
  contentEn?: string,
  contentDe?: string,
  categoryId?: string,
  postedAt?: number,
  thumbnail?: string,
  image?: string,
  active?: boolean
) {
  return request('POST', '/api/blog-posts', {
    title,
    titleEn,
    titleDe,
    slug,
    content,
    contentEn,
    contentDe,
    categoryId,
    postedAt,
    thumbnail,
    image,
    active,
  });
}

export async function update(
  id: string,
  title?: string,
  titleEn?: string,
  titleDe?: string,
  slug?: string,
  content?: string,
  contentEn?: string,
  contentDe?: string,
  categoryId?: string,
  postedAt?: number,
  thumbnail?: string,
  image?: string,
  active?: boolean
) {
  return request('POST', `/api/blog-posts/${id}`, {
    title,
    titleEn,
    titleDe,
    slug,
    content,
    contentEn,
    contentDe,
    categoryId,
    postedAt,
    thumbnail,
    image,
    active,
  });
}

export async function remove(id: string) {
  return request('DELETE', `/api/blog-posts/${id}`);
}

export async function listGallery(postId: string) {
  return request('GET', `/api/blog-posts/${postId}/gallery`);
}

export async function addGalleryImage(
  postId: string,
  payload: {
    imageUrl: string;
    width: number;
    height: number;
    alt?: string | null;
    altEn?: string | null;
    altDe?: string | null;
    sortOrder?: number | null;
  }
) {
  return request('POST', `/api/blog-posts/${postId}/gallery`, payload);
}

export async function updateGalleryOrder(postId: string, imageIds: string[]) {
  return request('POST', `/api/blog-posts/${postId}/gallery/order`, {
    imageIds,
  });
}

export async function removeGalleryImage(postId: string, imageId: string) {
  return request('DELETE', `/api/blog-posts/${postId}/gallery/${imageId}`);
}
